module.exports = __webpack_public_path__ + "img/wsy.1cbd77b3.png";